import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { LeafSprig } from "@/components/Motion";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found — Root2Shoot"
        siteName="Root2Shoot"
        description="The page you're looking for isn't here. Head back to Root2Shoot — sustainable café in Stockport and film & TV production catering."
      />
      <section className="relative flex min-h-[80svh] items-center overflow-hidden bg-noir" data-testid="not-found-page">
        <LeafSprig className="pointer-events-none absolute -left-8 bottom-6 h-72 -rotate-12 text-leaf-light/12" />
        <LeafSprig className="pointer-events-none absolute -right-8 top-24 h-72 rotate-[160deg] text-leaf-light/10" />
        <div className="mx-auto max-w-3xl px-5 py-32 text-center sm:px-8">
          <p className="label-mono justify-center">Lost off the call sheet</p>
          <h1 className="mt-6 font-editorial text-6xl leading-[1.0] tracking-tight text-cream sm:text-7xl">
            4<span className="text-gold">0</span>4
          </h1>
          <p className="mt-6 font-display text-2xl italic text-gold">This page didn't make the final cut.</p>
          <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-sage">
            The page you're looking for has moved or never existed. Let's get you back to the good stuff.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link to="/" className="btn-gold" data-testid="not-found-cta-home">Back to Home</Link>
            <Link to="/cafe" className="btn-ghost" data-testid="not-found-cta-cafe">See the Café Menu</Link>
          </div>
        </div>
      </section>
    </>
  );
}
